import { render, staticRenderFns } from "./customer-stage.vue?vue&type=template&id=ffdfdd5e&scoped=true&"
import script from "./customer-stage.vue?vue&type=script&lang=js&"
export * from "./customer-stage.vue?vue&type=script&lang=js&"
import style0 from "./customer-stage.vue?vue&type=style&index=0&id=ffdfdd5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdfdd5e",
  null
  
)

export default component.exports